import { combineReducers } from 'redux';
import { updateProfileInfoReducer } from './update-profile-info';
import { showUserReducer } from './show-user';

export default combineReducers({
  showUser: showUserReducer,
  updateProfileInfo: updateProfileInfoReducer,
});
